import { RegistrationRole } from '@pages/Login/constants';

export const TERMS_OF_USE_URL = 'https://lioinsurance.com/terms-of-use/';

export const GET_APPOINTED_URL =
  'https://lioinsurance.com/get-appointed/?utm_source=portal2&utm_medium=referral&utm_campaign=login';

export const BROKER_PARTNER_ID_REQUIRED_MESSAGE = 'An LIO Partner ID is required to register.';

export const getTitleForRole = (role?: RegistrationRole): string => {
  switch (role) {
    case RegistrationRole.POLICYHOLDER:
      return 'Policyholder Registration';
    case RegistrationRole.BILLING_CONTACT:
      return 'Billing Contact / Payer Registration';
    case RegistrationRole.BROKER_PRODUCER:
      return 'Broker/Producer Registration';
    default:
      return 'Create Account';
  }
};
